<header class="page-hero">
  <div class="container page-hero__inner">
    <div class="page-hero__accent"></div>
    <h2 class="page-hero__title">{{category.title | translate}}</h2>
    <p *ngIf="summary" class="page-hero__summary" [innerHTML]="summary"></p>
    <div class="page-hero__toolbar">
      <app-currency-selector></app-currency-selector>
      <app-category-buttons [categoryToAvoid]="category.name" [categoryInfos]="categoryInfos"
        (navigateAway)="gotoTarget($event)">
      </app-category-buttons>
    </div>
    @if (hasActivePromo) {
      <div class="promo-nudge mt-2">
        <i class="fas fa-tag mr-2"></i>
        {{'PRODUCTS.PROMO_NUDGE' | translate}}
      </div>
    }
  </div>
</header>
<div class="container fixed-sn skin-light mdb-skin-custom">
  <main style="padding-left: 0">
    <div class="container-fluid mt-0">
      <div class="row justify-content-center text-center">
        <div class="col-12 text-left mb-3 pl-0">
          <a routerLink="/home" class="back-btn">
            <i class="fas fa-arrow-left"></i>
            <span>{{ 'PRODUCTS.BACK_TO_CATEGORIES' | translate }}</span>
          </a>
        </div>
        <!--Section: Block Content-->
        <section>
          <!-- Grid row -->
          <div class="row products-grid">
            <!-- Grid column -->
            @for (item of visibleItems; track item) {
            <div class="col-md-4 mb-4 col-sm-auto" [ngClass]="item.selected ? 'selected' : ''">
              <!-- Card -->
              <div class="item-card"
                   [class.item-out-of-stock]="stock.isOutOfStock(item.reference) && !item.selected"
                   [class.item-selected]="item.selected"
                   (click)="openChoices(item)">
                <div class="view zoom overlay z-depth-2 rounded image-wrapper" [class.has-tryon]="item.tryonUrl">
                  <img class="img-fluid centered-img img-main" [src]="item.path" [alt]="item.reference" loading="lazy">
                  @if (item.tryonUrl) {
                    <img class="img-fluid centered-img img-tryon-hover" [src]="item.tryonUrl" [alt]="item.reference" loading="lazy">
                  }
                  <div class="mask rgba-black-slight"></div>
                  @if (item.selected) {
                    <div class="cart-badge"><i class="fas fa-shopping-cart"></i></div>
                  }
                  @if (stock.isOutOfStock(item.reference) && !item.selected) {
                    <div class="out-of-stock-overlay">Épuisé</div>
                  }
                  @if (item.tryonUrl && !item.selected) {
                    <div class="tryon-hint-badge" title="Voir avec mannequin IA">✨</div>
                  }
                  @if (!item.tryonUrl && !item.selected && !stock.isOutOfStock(item.reference)) {
                    <div class="tap-hint">{{ 'PRODUCTS.TAP_HINT' | translate }}</div>
                  }
                </div>
                <div class="item-card__info">
                  <span class="item-price">{{ pricing.format(item.price) }}</span>
                  <span class="item-ref">REF: {{item.reference}}</span>
                </div>
              </div>
              <!-- Card -->
            </div>
            }
            <!-- Grid column -->
          </div>
          <!-- Grid row -->
        </section>
        <!-- Sentinel pour IntersectionObserver -->
        <div #sentinel class="scroll-sentinel"></div>
        @if (hasMore) {
          <div class="scroll-loading">
            <span class="scroll-loading-dot"></span>
            <span class="scroll-loading-dot"></span>
            <span class="scroll-loading-dot"></span>
          </div>
        }
      </div>
    </div>
  </main>
</div>
<!--Section: Block Content-->

<!-- Lightbox article épuisé -->
<div *ngIf="lightboxSrc" class="portfolio-lightbox-overlay" (click)="closeLightbox()">
  <img [src]="lightboxSrc" class="portfolio-lightbox-img" (click)="$event.stopPropagation()" />
  <button class="portfolio-lightbox-close" (click)="closeLightbox()">✕</button>
</div>